module.exports = __webpack_public_path__ + "img/info_circle.a84bf047.svg";